import color from "../../constants/color";

const styles = {
  headingText:{
    fontSize:"18px",
    fontWeight:"500",
    m: "0 5px 5px 0",
    textTransform: "capitalize"
  },
  infoRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "60px",
    alignItems: "center",
  },
  inlineInfoContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "60px",
  },
  inlineInfoText: {
    fontSize: "18px",
    fontWeight: "500",
    m: "0 5px 5px 0"
  },
  filterButton:{ display:"flex",
    backgroundColor:color.secondary,
    color:color.card,
    borderRadius:"30px",
    // width:{ xs: "50%", md: "20%" },
    marginLeft:{ xs: 1, md: "8px" },
    alignItems:"center",
    paddingRight:2,
    mb:{ xs: "20px", md: 0 },
    
  },
  hoursInput: {
    width: "10em",
    borderRadius: "8px",
    height: "2em",

    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px",
      borderRadius: "8px",

    },
    "& .css-156w56f-MuiInputBase-root-MuiOutlinedInput-root": {
      borderRadius: "8px",

    },
  },
  dropDownMenu:{
    fontSize:"12px",
    my:"10px",

    fontWeight:"500",
    width: "100%",
    height: "40px"
  },
  btnSection: {
    display: {xs: "block", sm: "flex"}, 
    justifyContent:{ xs: "space-between", md: "end" },
    alignItems: { xs: "start", md: "end" },
    mt:{ xs: "20px", md: 0 }
  },
  icon:{
    fill:color.card,
    width: "20px",
    height: "20px",
    ml: "5px",
  },
  filterContainer:{
    position:"relative"
  },
  filterItem:{
    position:"absolute",
    zIndex:"999999"
  },
  calender:{
    // height:"40px"
  },
  calenderInput:{
    "& .MuiInputBase-input": {
      padding: "8.5px 14px"
    }
  },
  dropdownMenu:{
    fontSize:"14px",

    fontWeight:"400"
  },
}
export default styles;